<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>For my grandma Rose, whose tenacity and resilience have been a lifelong inspiration.</p><br/>
<p style="text-indent:0em">And for my grandad Tom, for all the adventures we’ve shared. May there be many more to come.</p><br/>
<p style="text-indent:0em">To my mum and dad for instilling in me a love of the outdoors and for their constant support over the years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4dae2e30